(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dh-product-question"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dh-watch-question')) {
    customElements.define('dh-watch-question', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-q-open]');
        const form = this.querySelector('form');
        const key = 'dh-question-response';
        const close = () => { dialog.close(); trigger.focus(); };
        trigger.addEventListener('click', () => dialog.showModal());
        this.querySelector('[data-q-close]').addEventListener('click', close);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        });
        form.addEventListener('submit', () => {
          try { sessionStorage.setItem(key, this.dataset.formId); } catch {}
        });
        let ownResponse = false;
        try { ownResponse = sessionStorage.getItem(key) === this.dataset.formId; } catch {}
        if (ownResponse && this.querySelector('[data-q-result]')) {
          requestAnimationFrame(() => {
            document.querySelectorAll('[data-dh-reservation-dialog][open]').forEach(other => other.close());
            dialog.showModal();
          });
          try { sessionStorage.removeItem(key); } catch {}
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
